import axios from 'axios'
import API from './API.js'
import config from '../config/config.js'

export default class Badges extends API {
  constructor() {
    // this.route = "badges";
    const imageFileds = ['image_path']
    super('badges', imageFileds)
  }

  async badgeStudents(badgeId) {
    const response = await axios.get(`/${this.route}/${badgeId}`)
    return response.data
  }

  async badgeToStudents(data) {
    // api >> /badges/{badge}/save_students
    const response = await axios.post(
      `/${this.route}/${data.id}/save_students`,
      data,
    )
    return response.data
  }
  //
}
